import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { TmsWebBaseChartService } from '../base';
import { ChartWeeksSalesInvoices } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class ChartWeeksSalesInvoiceService extends TmsWebBaseChartService<ChartWeeksSalesInvoices> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('ChartWeeksSalesInvoices');
  }
}
